/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/getProjectsOverrides';
import type { GetProjectsQueryParams } from '../../operation-overrides/getProjectsOverrides';

export type { GetProjectsQueryParams };

export interface Input {
  apiVersion?: string;
  query?: GetProjectsQueryParams;
}

export async function getProjects(
  { apiVersion, query }: Input = {},
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects', {
    params: {
      // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
      query,
    },
    // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
    querySerializer: overrides.querySerializer,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
